import React from "react";
import { CaseStageEnum } from "../../../../../src/api/caseStages";
import { useAppSelector } from "../../../../../src/app/store";
import { useLoggedInUserId } from "../../../../../src/features/auth/logic/rbac";
import WorkflowStageBanner from "../../../../../src/features/stageWorkflow/components/WorkflowStageBanner";
import { selectStageConfigByStage } from "../../logic/slice";
import WorkflowStageInfoBanner from "../../../../../src/features/stageWorkflow/components/WorkflowStageInfoBanner";
import { selectParticipantByType } from "../../../../../src/features/caseinfo/logic/ParticipantsSlice";
import { ParticipantType } from "../../../../../src/api/participants";

const DoAssignIoAppAuthStage: React.FC = () => {
  const loggedInUserId = useLoggedInUserId();

  const dealingAuthorityParticipant = useAppSelector((state) =>
    selectParticipantByType(state, ParticipantType.CASE_DEALING_OFFICER)
  );

  const dealingAuthority = dealingAuthorityParticipant?.participant_id;

  const stageConfig = useAppSelector(selectStageConfigByStage(CaseStageEnum.DO_NOMINATE_IO_APP_AUTH));

  const isDealingAuthority = loggedInUserId === dealingAuthority;

  if (isDealingAuthority) {
    return (
      <WorkflowStageBanner
        title="Nominate IO Appointing Authority"
        description="Identify the competent authority for appointing Investigating Officer. Once nominated, the case will be forwarded for confirmation to relevant authorities."
        actions={stageConfig?.actions}
      />
    );
  }

  return (
      <WorkflowStageInfoBanner
        title="Pending with Dealing Officer to Nominate IO Appointing Authority"
      />
  );
};

export default DoAssignIoAppAuthStage;
